export default __webpack_public_path__ + "static/media/img_demo_02_m.7e2ecfb4.jpg";